module.exports = __webpack_public_path__ + "static/img/ss01@2x.ae592676.png";